import React, { useContext, useEffect, useState } from 'react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ShareCodeButton from '../share/ShareCodeButton';
import { GameContext } from '../GameContext';
import { getPlayersStatus, updatePlayerIdentity } from '../utils/dbUtils';
import { useParams, useLocation } from 'react-router-dom';
import PlayerAvatar from '../PlayerAvatar';
import AvatarPicker from '../AvatarPicker';
import { identityFor } from '../../playerIdentity';
import { readSaved, save } from '../../gameDeck';

export default function PlayerStatus({ onEditingChange }) {
  const { setGameCode, playerId: contextPlayerId, players, setPlayers } = useContext(GameContext);
  const { urlGameCode: code } = useParams();
  const playerId = readSaved(code + '_data', {})?.playerId || contextPlayerId;
  const location = useLocation();
  const [editing, setEditing] = useState(false), [identity, setIdentity] = useState({});
  const [busy, setBusy] = useState(false), [photoBusy, setPhotoBusy] = useState(false), [error, setError] = useState('');
  const onSharePage = location.pathname.includes('/share');
  useEffect(() => { onEditingChange?.(editing); return () => onEditingChange?.(false); }, [editing, onEditingChange]);
  useEffect(() => {
    setGameCode(code);
    return getPlayersStatus(code).subscribe(list => {
      setPlayers(list.map(player => ({
        id: Number(player.id.slice(6)), playerId: player.id,
        ...identityFor(player), name: player.name || (player.id === playerId ? 'You' : 'Joining…'),
        isReady: player.isReady === true, isPlaceholder: false,
      })));
    });
  }, [code, playerId, setPlayers, setGameCode]);
  async function savePicture() {
    setBusy(true); setError('');
    try {
      await updatePlayerIdentity(code, playerId, identity);
      const key = `diyt-draft-${code}-${playerId}`;
      save(key, { ...readSaved(key, {}), identity });
      setEditing(false);
    } catch { setError('Your picture hasn’t saved. Check your connection and try again.'); }
    finally { setBusy(false); }
  }
  return <div className="creative-roster-wrap">
    <ul className="creative-roster" aria-label="Players at your table">
      {players.filter(p => !p.isPlaceholder).map(player => <li key={player.playerId}>
        {player.playerId === playerId ? <button type="button" className="player-picture-edit" aria-label="Change my picture" aria-expanded={editing} onClick={() => { setIdentity(identityFor(player)); setEditing(v => !v); setError(''); }}><PlayerAvatar player={player} /></button> : <PlayerAvatar player={player} />}
        <strong>{player.name}</strong>{!onSharePage && <small className={player.isReady ? 'is-ready' : ''}>{player.isReady ? 'Ready' : 'Writing'}</small>}
      </li>)}
      {Array.from({ length: Math.max(0, 4 - players.length) }, (_, i) => <li key={`invite-${i}`}><div className="player-invite"><ShareCodeButton code={code} icon={PersonAddIcon} /></div><strong>Invite</strong></li>)}
    </ul>
    {editing && <div className="roster-editor"><AvatarPicker value={identity} onChange={setIdentity} initiallyOpen disabled={busy} onBusyChange={setPhotoBusy} /><div className="avatar-photo-actions"><button type="button" className="avatar-primary" onClick={savePicture} disabled={busy || photoBusy}>{busy ? 'Saving…' : 'Save picture'}</button><button type="button" disabled={busy} onClick={() => setEditing(false)}>Cancel</button></div>{error && <p role="alert" className="error-message">{error}</p>}</div>}
  </div>;
}
